const isEmptyElement = require('./isEmptyElement');

const trimEnd = (editorStateInner) => {
  const clone = { ...editorStateInner }; // clone editor state
  const { value: elements } = clone;
  if (elements.length === 0 || !isEmptyElement(elements[elements.length - 1])) {
    return editorStateInner;
  }
  const newValues = [...elements];
  clone.value = newValues.slice(0, -1);
  if (clone.value.length === 0) {
    return clone;
  }
  return trimEnd(clone);
};

module.exports = trimEnd;
